import { render } from "./content-placeholders-img.vue?vue&type=template&id=3a541f98&ts=true"
import script from "./content-placeholders-img.vue?vue&type=script&lang=ts"
export * from "./content-placeholders-img.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__